import React from 'react';
import { useParams } from 'react-router-dom';
import ChallanForm from './ChallanForm';

const EditChallan = () => {
  const { id } = useParams();

  return <ChallanForm challanId={id} />;
};

export default EditChallan; 